import { createBrowserRouter } from 'react-router-dom';
import { Shell } from './components/Shell';
import { SignIn } from './screens/SignIn';
import { Verify } from './screens/Verify';
import { ServiceType } from './screens/ServiceType';
import { Intake } from './screens/Intake';
import { Dashboard } from './screens/Dashboard';
import { AdminConsole } from './screens/AdminConsole';
import { Leads } from './screens/admin/Leads';
import { AdminDashboard } from './screens/admin/AdminDashboard';
import { EstimateEdit } from './screens/admin/EstimateEdit';
import { Contractors } from './screens/admin/Contractors';
import { ProjectBids } from './screens/admin/ProjectBids';
import { QuickScope } from './screens/QuickScope';
import { Capture } from './screens/Capture';
import { Submitted } from './screens/Submitted';
import { Range } from './screens/Range';
import { DesignWelcome } from './screens/design/DesignWelcome';
import { DesignFlow } from './screens/design/DesignFlow';
import { SpecReady } from './screens/design/SpecReady';
import { Paid } from './screens/design/Paid';
import { ProjectStart } from './screens/design/ProjectStart';
import { ProjectSummary } from './screens/design/ProjectSummary';
import { PaintBranch } from './screens/design/PaintBranch';
import { TalkItThrough } from './screens/TalkItThrough';
import { BidResponse } from './screens/BidResponse';
import { ContractorDashboard } from './screens/ContractorDashboard';

function withShell(node: JSX.Element): JSX.Element {
  return <Shell>{node}</Shell>;
}

export const router = createBrowserRouter([
  // Stage zero
  { path: '/', element: withShell(<SignIn />) },
  { path: '/verify', element: withShell(<Verify />) },
  { path: '/intake', element: withShell(<Intake />) },
  { path: '/dashboard', element: withShell(<Dashboard />) },
  { path: '/admin', element: withShell(<AdminConsole />) },
  { path: '/admin/dashboard', element: withShell(<AdminDashboard />) },
  { path: '/admin/leads', element: withShell(<Leads />) },
  { path: '/admin/estimate/:projectId', element: withShell(<EstimateEdit />) },
  { path: '/admin/manage-contractors', element: withShell(<Contractors />) },
  { path: '/admin/bids/:projectId', element: withShell(<ProjectBids />) },
  { path: '/service', element: withShell(<ServiceType />) },
  { path: '/quick-scope', element: withShell(<QuickScope />) },
  { path: '/capture', element: withShell(<Capture />) },
  { path: '/submitted', element: withShell(<Submitted />) },
  { path: '/range', element: withShell(<Range />) },
  // Escapes
  { path: '/talk', element: withShell(<TalkItThrough />) },
  // Public contractor bid response (no login) — from the bid email link.
  { path: '/bid/:token', element: withShell(<BidResponse />) },
  // Contractor portal (logged-in contractor's jobs).
  { path: '/contractor', element: withShell(<ContractorDashboard />) },
  // Design phase — data-driven. Welcome, then the flow fetches the question set
  // and walks it. DataFlowProvider (inside DesignFlow) owns the session.
  { path: '/design/welcome', element: withShell(<DesignWelcome />) },
  { path: '/design/project-start', element: withShell(<ProjectStart />) },
  { path: '/design/paint', element: withShell(<PaintBranch />) },
  { path: '/design/flow', element: withShell(<DesignFlow />) },
  { path: '/design/estimate', element: withShell(<SpecReady />) },
  { path: '/design/project', element: withShell(<ProjectSummary />) },
  { path: '/design/submitted', element: withShell(<Paid />) },
]);
